import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import LoadingSpinner from "../pages/LoadingSpinner";

export default function LoginPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!username.trim() || !password) {
      toast.error("कृपया युझरनेम आणि पासवर्ड टाका!");
      return;
    }

    setLoading(true);

    setTimeout(() => {
      localStorage.setItem("token", "mock-static-jwt-token-12345");
      localStorage.setItem("username", username.trim());
      localStorage.setItem("userRole", "Super Admin");
      localStorage.setItem("fkDoctorId", "1");

      setLoading(false);
      toast.success("Login Successful. 🎉");
      navigate("/dashboard", { replace: true });
    }, 2000); 
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div 
      style={{ 
        minHeight: "100vh", 
        width: "100%",
        backgroundColor: "#e2e8f0", // Slightly darker grey to contrast the white paper pop-out
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: isMobile ? "0" : "40px",
        boxSizing: "border-box",
        fontFamily: "'Inter', 'Poppins', sans-serif"
      }}
    >
      <div 
        style={{ 
          width: "100%",
          maxWidth: "1100px",
          minHeight: isMobile ? "100vh" : "580px", 
          borderRadius: isMobile ? "0" : "16px",
          backgroundColor: "#ffffff",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          boxShadow: isMobile ? "none" : "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
          position: "relative"
        }}
      >
        {/* LEFT PANEL — Image Section */}
        <div 
          style={{
            width: isMobile ? "100%" : "52%",
            height: isMobile ? "35vh" : "auto", 
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            padding: isMobile ? "24px" : "40px",
            backgroundImage: `linear-gradient(to bottom, rgba(3, 117, 137, 0.1), rgba(15, 23, 42, 0.85)), url('/images/loggin.jpg')`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            color: "#fff",
            boxSizing: "border-box",
            zIndex: 1
          }}
        >
          {/* Top Identity */}
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <div style={{ width: "8px", height: "24px", backgroundColor: "#037589", borderRadius: "4px" }} />
            <div>
              <h4 style={{ margin: 0, fontSize: "15px", fontWeight: "700", letterSpacing: "0.5px" }}>SCHOOL PORTAL</h4>
            </div>
          </div>

          <div>
            <h3 style={{ fontSize: isMobile ? "18px" : "24px", margin: 0, fontWeight: "600", letterSpacing: "-0.3px" }}>
              Safe. Secure. Reliable.
            </h3>
            <p style={{ fontSize: "13px", margin: "4px 0 0 0", opacity: 0.8 }}>
              Your trusted professional school portal.
            </p>
          </div>
        </div>

        {/* RIGHT PANEL — Multi-layered Lifted/Folded Paper Look */}
        <div 
          style={{ 
            width: isMobile ? "100%" : "48%",
            height: isMobile ? "65vh" : "auto", 
            display: "flex", 
            flexDirection: "column",
            justifyContent: "center", 
            alignItems: "center",
            padding: isMobile ? "24px" : "40px",
            background: "#ffffff",
            boxSizing: "border-box",
            position: "relative",
            zIndex: 5,
            // 🛠️ Heavy custom left-directed overlapping shadows to give a real folded/overlapping paper overlay feel
            boxShadow: isMobile ? "none" : "-25px 0 30px -10px rgba(0, 0, 0, 0.15), -10px 0 10px -5px rgba(0, 0, 0, 0.1)",
            borderLeft: isMobile ? "none" : "1px solid rgba(0,0,0,0.02)"
          }}
        >
          <div style={{ width: "100%", maxWidth: "330px" }}>
            
            {/* Logo Section inside Welcome Text */}
            <div style={{ textAlign: "center", marginBottom: "28px" }}>
              <img
                src="/images/logo.jpg"
                alt="Logo"
                style={{ 
                  width: 65, 
                  height: 65, 
                  marginBottom: "12px", 
                  display: "inline-block", 
                  borderRadius: "50%",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.08)" 
                }}
              />
              <h2 style={{ fontSize: "22px", fontWeight: 700, color: "#0b5070", margin: "0 0 4px 0" }}>
                Welcome Back
              </h2>
              <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>
                Please login to your account
              </p>
            </div>

            <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", width: "100%" }}>
              
              {/* Inputs Container */}
              <div style={{ display: "flex", flexDirection: "column", gap: "18px", width: "100%" }}>
                
                {/* Username Input */}
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <label style={{ fontSize: "12px", color: "#475569", fontWeight: "600" }}>Username *</label>
                  <div style={{ position: "relative" }}>
                    {/* User Icon */}
                    <div style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", color: "#94a3b8" }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>
                    </div>
                    <input
                      type="text"
                      required
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      style={{ 
                        width: "100%", 
                        height: "40px", 
                        border: "1px solid #cbd5e1", 
                        borderRadius: "8px", 
                        padding: "0 12px 0 38px", 
                        fontSize: "14px", 
                        boxSizing: "border-box", 
                        outline: "none", 
                        transition: "all 0.2s" 
                      }}
                      placeholder="Enter username"
                      onFocus={(e) => {
                        e.target.style.borderColor = "#037589";
                        e.target.style.boxShadow = "0 0 0 3px rgba(3, 117, 137, 0.15)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#cbd5e1";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                  </div>
                </div>

                {/* Password Input */}
                <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                  <label style={{ fontSize: "12px", color: "#475569", fontWeight: "600" }}>Password *</label>
                  <div style={{ position: "relative" }}>
                    {/* Lock Icon */}
                    <div style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)", display: "flex", alignItems: "center", color: "#94a3b8" }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
                    </div>
                    <input
                      type={showPassword ? "text" : "password"}
                      required
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      style={{ 
                        width: "100%", 
                        height: "40px", 
                        border: "1px solid #cbd5e1", 
                        borderRadius: "8px", 
                        padding: "0 44px 0 38px", 
                        fontSize: "14px", 
                        boxSizing: "border-box", 
                        outline: "none", 
                        transition: "all 0.2s" 
                      }}
                      placeholder="Enter password"
                      onFocus={(e) => {
                        e.target.style.borderColor = "#037589";
                        e.target.style.boxShadow = "0 0 0 3px rgba(3, 117, 137, 0.15)";
                      }}
                      onBlur={(e) => {
                        e.target.style.borderColor = "#cbd5e1";
                        e.target.style.boxShadow = "none";
                      }}
                    />
                    {/* Toggle Button */}
                    <button
                      type="button"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{
                        position: "absolute",
                        right: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        background: "none",
                        border: "none",
                        cursor: "pointer",
                        color: "#037589",
                        fontSize: "12px",
                        fontWeight: "600",
                        padding: 0
                      }}
                    >
                      {showPassword ? "Hide" : "Show"}
                    </button>
                  </div>
                </div>
              </div>

              {/* Login Button */}
              <button
                type="submit"
                style={{
                  width: "100%",
                  height: "42px",
                  marginTop: "28px",
                  borderRadius: "8px",
                  backgroundColor: "#037589",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "15px",
                  boxShadow: "0 4px 12px rgba(3,117,137,0.2)",
                  transition: "all 0.2s"
                }}
                onMouseOver={(e) => e.target.style.backgroundColor = "#025b6b"}
                onMouseOut={(e) => e.target.style.backgroundColor = "#037589"}
              >
                Login
              </button>

            </form>
          </div>
        </div>
      </div>
    </div>
  );
}